import React from 'react';
import { motion } from 'framer-motion';
import { Scale, FileText, Puzzle, Landmark } from 'lucide-react';
export const Included = () => {
  const items = [{
    icon: <Scale className="w-8 h-8 text-gold-500" data-id="element-139" />,
    title: '⚖️ Reclamos con estrategia',
    desc: 'Aprendé cómo encuadrar jurídicamente cada caso, qué reclamar y qué fundamentos utilizar para evitar errores que puedan debilitar tu presentación.'
  }, {
    icon: <FileText className="w-8 h-8 text-gold-500" data-id="element-140" />,
    title: '📄 Modelos profesionales listos para usar',
    desc: 'Accedé a escritos editables listos para adaptar y presentar en casos reales.'
  }, {
    icon: <Puzzle className="w-8 h-8 text-gold-500" data-id="element-141" />,
    title: '🧩 Casos prácticos y situaciones frecuentes',
    desc: 'Bancos, tarjetas, fintech, estafas digitales, compras online, seguros, servicios públicos y mucho más.'
  }, {
    icon: <Landmark className="w-8 h-8 text-gold-500" data-id="element-142" />,
    title: '🏛️ Del reclamo administrativo a la demanda judicial',
    desc: 'Conocé cuándo corresponde avanzar judicialmente y cómo estructurar el proceso paso a paso.'
  }];
  return <section className="py-20 bg-legal-900" data-id="element-143">
      <div className="container mx-auto px-4" data-id="element-144">
        <div className="text-center mb-16" data-id="element-145">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-146">
            ¿Qué vas a encontrar adentro?
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-147">
          {items.map((item, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="bg-legal-800 border border-legal-700 p-8 rounded-xl hover:border-gold-500/50 transition-colors group" data-id="element-148">
              <div className="mb-6 p-3 bg-legal-900 rounded-lg inline-block group-hover:scale-110 transition-transform" data-id="element-149">
                {item.icon}
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-150">
                {item.title}
              </h3>
              <p className="text-slate-400 leading-relaxed" data-id="element-151">{item.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};